//import fetch from 'cross-fetch'

export const REQUEST_NODE = 'REQUEST_NODE'
export const RECEIVE_NODE = 'RECEIVE_NODE'
export const ERROR_NODE = 'ERROR_NODE'
export const REQUEST_FORM = 'REQUEST_FORM'
export const RECEIVE_FORM = 'RECEIVE_FORM'
export const INVALIDATE_FORM = 'INVALIDATE_FORM'
export const SET_FORM_VALUE = 'SET_FORM_VALUE'

function requestNode(id) {
  return {
    type: REQUEST_NODE,
    id: id
  }
}

function receiveNode(json, id) {
  return {
    type: RECEIVE_NODE,
    id: id,
    node: json,
    receivedAt: Date.now()
  }
}

function errorNode(err, id) {
  return {
    type: ERROR_NODE,
    id: id,
    err: err,
    receivedAt: Date.now()
  }
}

function fetchNode(id) {
  return dispatch => {
    dispatch(requestNode(id))
    return fetch('//jeff.4zzz.org.au/' + id + '?_format=json')
      .then(response => {
        if (!response.ok) {
          throw(new Error('Fetch not ok!'))
        }
        return response
      })
      .then(response => response.json())
      .then(json => dispatch(receiveNode(json, id)))
      .catch(err => dispatch(errorNode(err, id)))
  }
}

function shouldFetchNode(state, id) {
  //const nodes = state.nodes
  const node = state.nodes[id]
  if (!node) {
    return true
  } else if (node.isFetching) {
    return false
  } else {
    return node.didInvalidate
  }
}

export function fetchNodeIfNeeded(id) {
  return (dispatch, getState) => {
    if (shouldFetchNode(getState(), id)) {
      return dispatch(fetchNode(id))
    }
  }
}

export function invalidateForm() {
  return {
    type: INVALIDATE_FORM
  }
}

function requestForm() {
  return {
    type: REQUEST_FORM
  }
}

function receiveForm(json) {
  let formValues = {}
  Object.keys(json).map((item, index) => {
    if (!item.match(/^#[\w]+/)){
      item = json[item]
      var type = item['#type']
      var name = item['#name']
      if (type !== 'webform_actions') {
        formValues['webform_id'] = item['#webform']
        formValues[name] = item['#default_value']
      }
    }
  })
  return {
    type: RECEIVE_FORM,
    form: json,
    formValues: formValues,
    receivedAt: Date.now()
  }
}

function fetchForm() {
  return dispatch => {
    dispatch(requestForm())
    return fetch('//jeff.4zzz.org.au/webform_rest/elements/contact?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveForm(json)))
  }
}

function shouldFetchForm(state) {
  const forms = state.forms
  if (Object.keys(forms.form).length === 0) {
    return true
  } else if (forms.isFetching) {
    return false
  } else {
    return forms.didInvalidate
  }
}

export function fetchFormIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchForm(getState())) {
      return dispatch(fetchForm())
    }
  }
}

export function setFormValue(name, value) {
  return {
    type: SET_FORM_VALUE,
    name: name,
    value: value,
  }
}

function postingForm() {
  return {
    type: POSTING_FORM
  }
}

function postedForm(json) {
  return {
    type: POSTED_FORM,
    response: json
  }
}

export function postForm(formValues) {
  return dispatch => {
    dispatch(postingForm())
    fetch('//jeff.4zzz.org.au/webform_rest/submit', {
      method: 'POST',
      body: JSON.stringify(formValues),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(response => response.json())
    .catch(error => console.error('Error:', error))
    .then(json => dispatch(postedForm(json)))
  }
}
